import MyLists from 'components/RichProfile/MyLists/MyLists';
import { withMyListsProps } from 'viewModel/richProfile/myLists/withMyListsProps';

export default withMyListsProps(MyLists);
